// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fON7h","comment":"styles_comment__16Rz-"};